import { TemplatePage } from './types';

const live_streaming_promo_page: TemplatePage = {
  header: {
    color: '#F8E33A',
    icon: 'images/video-templates/live_promo.jpg',
    title: 'Live Stream Promo Templates',
    title_meta: '20+ Free Live Stream Promo Video Templates',
    description_meta:
      'Make stunning videos to promote your live shows everywhere with the help of Wave.video’s easily ' +
      'customizable video templates. Get as many viewers as possible!',
    description:
      'Promote your live stream on every platform with the help of easily customizable templates. Mix your ' +
      'talking-head video with our stylish design elements and make a video invitation that stands out.'
  },
  footer: {
    category: 'Live streaming promo',
    description:
      'With Wave.video’s collection of editable live stream promo templates, you will attract new audiences on ' +
      'every marketing channel: Stories, social media feed, email, or ads. Pick a free template that matches your ' +
      'style and easily repurpose your promotional video for every platform. Our broad collection of customizable ' +
      'layouts and overlays will help you make diverse and professional promo videos and grow your fan base every day.'
  },
  content: [
    {
      type: 'templates',
      title: 'Live streaming promo',
      search: { name: 'LivePromo', tags: 'LivePromo' }
    },
    {
      type: 'stocks',
      title: 'live streaming promo',
      search: { name: 'live streaming promo' }
    },
    { type: 'calendar' }
  ]
};

export default live_streaming_promo_page;
